<template>
    <rkm-application>
        <template v-if="autenticado">
            <Header @toggle="handleToggle" />

            <Sidebar :open="open" />

            <rkm-main :open="open">
                <slot />
            </rkm-main>

            <rkm-toast
                v-model="exportacaoBpa.visible"
                color="success"
                no-auto-hide
                solid
                title="BPA - Exportação"
            >
                O arquivo <a href="#" @click.prevent="handleExportacaoBpaDownload(exportacaoBpa.id)">{{ exportacaoBpa.arquivo }}</a> está pronto para download.
            </rkm-toast>

            <rkm-toast
                v-model="exportacaoEsus.visible"
                color="success"
                no-auto-hide
                solid
                title="Atenção básica - Exportação"
            >
                O arquivo <a href="#" @click.prevent="handleExportacaoEsusDownload(exportacaoEsus.id)">{{ exportacaoEsus.arquivo }}</a> está pronto para download.
            </rkm-toast>
        </template>
    </rkm-application>
</template>

<script>
// Components.
import Header from '@/Layout/Components/Header'
import Sidebar from '@/Layout/Components/Sidebar'

// Mixins.
import { file, repository } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

// Others.
import Pusher from 'pusher-js'
import { repositoryFactory } from '@/repositories/repositoryFactory'

export default {
    components: {
        Header,
        Sidebar,
    },
    computed: {
        ...mapGetters({
            autenticacao: 'getAutenticacao',
            customer: 'getCustomer',
            exportacaoBpaEmAndamento: 'getExportacaoBpaEmAndamento',
            exportacaoEsusEmAndamento: 'getExportacaoEsusEmAndamento',
            lotacao: 'getLotacao',
            open: 'getSidebar',
        }),
        autenticado() {
            return this.autenticacao
        },
    },
    created() {
        this.repositories = {
            exportacaoBpa: this.getConectaSusRepository('bpa.exportacao'),
            exportacaoEsus: this.getConectaSusRepository('atencaoBasica.exportacao'),
        }

        this.load()
    },
    data: () => ({
        exportacaoBpa: {
            id: null,
            arquivo: null,
            visible: false,
        },
        exportacaoEsus: {
            id: null,
            arquivo: null,
            visible: false,
        },
        pusher: null,
    }),
    methods: {
        ...mapActions([
            'setExportacaoBpaEmAndamento',
            'setExportacaoEsusEmAndamento',
            'setLoading',
            'setSidebar',
            'unsetLoading',
        ]),
        init() {
            this.connect()

            if (this.exportacaoBpaEmAndamento) {
                this.pusher.subscribe(`private-${this.customer.link}-bpa-exportacao-finalizada-usuario.${this.lotacao.usuarioId}`)
                    .bind('ExportacaoFinalizada', (data) => {
                        this.exportacaoBpa.id = data.exportacaoId
                        this.exportacaoBpa.arquivo = data.exportacaoArquivo
                        this.exportacaoBpa.visible = true
                        this.setExportacaoBpaEmAndamento(false)
                    })
            }

            if (this.exportacaoEsusEmAndamento) {
                this.pusher.subscribe(`private-${this.customer.link}-atencao-basica-exportacao-finalizada-usuario.${this.lotacao.usuarioId}`)
                    .bind('ExportacaoFinalizada', (data) => {
                        this.exportacaoEsus.id = data.exportacaoArquivoId
                        this.exportacaoEsus.arquivo = data.exportacaoArquivoNome
                        this.exportacaoEsus.visible = true
                        this.setExportacaoEsusEmAndamento(false)
                    })
            }
        },
        load() {
            if (this.exportacaoBpaEmAndamento || this.exportacaoEsusEmAndamento) {
                this.init()
            }
        },
        handleToggle() {
            this.setSidebar(!this.open)
        },
        handleExportacaoBpaDownload(id) {
            this.setLoading()

            this.repositories.exportacaoBpa.download(id)
                .then(response => {
                    const file = response.headers['content-disposition'].split('filename=')[1]
                    const blob = new Blob([response.data])
                    const link = document.createElement('a')

                    link.href = URL.createObjectURL(blob)
                    link.download = file
                    link.click()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleExportacaoEsusDownload(id) {
            this.setLoading()

            this.repositories.exportacaoEsus.download(id)
                .then(response => {
                    const file = response.headers['content-disposition'].split('filename=')[1]
                    const blob = new Blob([response.data])
                    const link = document.createElement('a')

                    link.href = URL.createObjectURL(blob)
                    link.download = file
                    link.click()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        connect() {
            if (this.pusher === null) {
                this.pusher = new Pusher(process.env.VUE_APP_WS_APP_KEY, {
                    wsHost: process.env.VUE_APP_WS_HOST,
                    wsPort: process.env.VUE_APP_WS_PORT,
                    forceTLS: false,
                    enabledTransports: ['ws'],
                    authorizer: (channel) => ({
                        authorize: (socketId, callback) => {
                            const repository = repositoryFactory.get('conectaSus.websocket')

                            repository.login({
                                    token: socketId + ':' + channel.name
                                })
                                .then(response => callback(null, { auth: response }))
                                .catch(error => console.error(error))
                        }
                    })
                })
            }
        },
        disconnect() {
            if (this.pusher) {
                this.pusher.disconnect()
                this.pusher = null
            }
        },
        handlePusherConnection() {
            if (this.exportacaoBpaEmAndamento || this.exportacaoEsusEmAndamento) {
                this.init()
            } else {
                this.disconnect()
            }
        },
    },
    mixins: [file, repository],
    watch: {
        exportacaoBpaEmAndamento() {
            this.handlePusherConnection()
        },
        exportacaoEsusEmAndamento() {
            this.handlePusherConnection()
        },
    },
}
</script>